import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

import {
    LinkButton,
    ILinkButtonProps
} from '../link-button';
import { Icons } from '../icons';

export interface ICloseButtonProps extends Omit<ILinkButtonProps, 'label' | 'icon'> {}

export const CloseButton = ({ className, ...rest }: ICloseButtonProps) => (
    <LinkButton
        className={clsx(className, 'close-button')}
        icon={<Icons.IconClose />}
        {...rest}
    />
);
